import axios from "axios";
import { getAccessToken, getBackendUrl } from "api/common";
import { formatErrorMessage } from "logging/helpers";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { registerAxiosAuthInterceptor } from "app/Auth/axiosAuthInterceptor";

axios.defaults.headers.post["Content-Type"] = "application/json";
const dropsHttpClient = axios.create();

dropsHttpClient.interceptors.request.use(async (config) => {
  try {
    const url = (config.url?.startsWith("/") ? "" : "/") + config.url;
    const accessToken = await getAccessToken();
    const authHeader = `Bearer ${accessToken}`;
    // eslint-disable-next-line no-param-reassign -- Interceptor function
    config.url = `${getBackendUrl()}${url}`;
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = authHeader;
    return config;
  } catch (error) {
    /**
     * An error from getAccessToken indicates that the access token
     * is missing in local storage or could not be refreshed.
     * We reload the page to remount the AuthBoundary and reauthenticate the user.
     */
    log(
      LogLevel.error,
      "dropsHttpClient.interceptors",
      formatErrorMessage(error),
    );
    window.location.reload();
    throw error;
  }
});

registerAxiosAuthInterceptor(dropsHttpClient);

export { dropsHttpClient };
